import TileLayer from "ol/layer/Tile";

interface AnimateLayerTransitionOptions {
    previousLayer: TileLayer<any> | null;
    newLayer: TileLayer<any>;
    setLayers: (layers: TileLayer<any>[]) => void;
    duration?: number;
    opacity?: number;
}

let globalAnimationFrame: number | null = null;

export function animateLayerTransition({
    previousLayer,
    newLayer,
    setLayers,
    duration = 300,
    opacity = 1
}: AnimateLayerTransitionOptions) {
    // Отменяем любую предыдущую анимацию
    if (globalAnimationFrame !== null) {
        cancelAnimationFrame(globalAnimationFrame);
        globalAnimationFrame = null;
    }

    newLayer.setOpacity(0);

    if (previousLayer) {
        setLayers([previousLayer, newLayer]);
    } else {
        setLayers([newLayer]);
    }

    let start = performance.now();

    function animate(now: number) {
        const progress = Math.min((now - start) / duration, opacity);

        if (previousLayer) previousLayer.setOpacity(opacity - progress);
        newLayer.setOpacity(progress);

        if (progress < opacity) {
            globalAnimationFrame = requestAnimationFrame(animate);
        } else {
            setLayers([newLayer]);
            globalAnimationFrame = null;
        }
    }

    globalAnimationFrame = requestAnimationFrame(animate);
}
